import React from "react";

export function SelectField({ id, label, value, onChange, options }) {
  return (
    <div className="relative">
      <select
        id={id}
        required
        value={value}
        onChange={onChange}
        className="block w-full rounded border border-gray-300 bg-white py-3 px-3 text-base appearance-none focus:outline-none focus:border-blue-500"
      >
        <option value="" disabled hidden>
          {label}
        </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <label
        htmlFor={id}
        className="absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700"
      >
        {label}
      </label>
    </div>
  );
}
